import { DropItem } from "./DropItem";
import Phaser from 'phaser';
import BaseLevelScene from "src/app/Scenes/BaseLevelScene";
import { BaseSpriteInterface } from "./SpriteInterfaces";
import MainScene from "src/app/Scenes/MainScene";

export interface KeyData extends BaseSpriteInterface{
    scene: BaseLevelScene | MainScene;
    x: number;
    y: number;
    unlocks: string[];
}

export class KeyItem extends Phaser.Physics.Matter.Sprite {
  static sound: Phaser.Sound.BaseSound;
  birthTime: number;
  minLifeSpan: number = 250; //(ms) Min time before this can be picked up
  unlocks: string[];
  constructor(data: KeyData, playerScale=1) {
    let { scene, x, y, unlocks } = data;
    super(scene.matter.world, x, y, 'keys', 'keys_0');
    this.name = 'key';
    this.unlocks = unlocks;
    this.scene.add.existing(this);
    const Bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
    var circleCollider = Bodies.circle(this.x, this.y, 20*playerScale, {
      isSensor: true,
      label: 'keySensor',
    });
    this.setExistingBody(circleCollider);
    this.setFrictionAir(1);
    this.setScale(playerScale);
    this.setDepth(0);
    this.birthTime = Date.now();
    this.setVisible(true);
  }

  static preload(scene) {
    // Load gem data
    scene.load.atlas(
      'keys',
      'assets/items/keys.png',
      'assets/items/keys_atlas.json'
    );
  }

  pickup() {
    if (Date.now() - this.birthTime >= this.minLifeSpan) {
        DropItem.sound.play();
        this.destroy();
        return true;
    }
    return false;
  }
}
